import React from "react";
const StrategyGridContext = React.createContext();
export default StrategyGridContext;